import React, { Component } from 'react';
import PropTypes from 'prop-types';

class NavSubmenuTrigger extends Component {
  getItems() {
    const { items } = this.props;

    return items.map(({ Component, children, ...rest }, i) => (
      <Component key={i} className={'nav-submenu__item'} {...rest}>
        {children}
      </Component>
    ));
  }

  render() {
    const items = this.getItems();

    return <div className={'nav-submenu'}>{items}</div>;
  }
}

NavSubmenuTrigger.propTypes = {
  items: PropTypes.array.isRequired,
};

export default NavSubmenuTrigger;
